const IGNORABLE_DOMAINS = ['@sequencehq.com']

/**
 * Determines if session recording should be disabled based on the user's email domain.
 * Internal users should not have their sessions recorded to avoid billing costs.
 */
export const shouldDisableSessionRecording = (email: string): boolean => {
  return IGNORABLE_DOMAINS.some(domain => email.toLowerCase().endsWith(domain))
}
